import React, {useMemo} from 'react'
import {useTranslation} from '@lib/intl/useTranslations'
import {useRouter} from 'next/router'

import {getLinkUrl, URL_AI, URL_CHART, URL_MEME} from '@constant/url'
import {MatchingType} from '@component/buttons/WizNavButton'
import {WMOption} from '@component/menu/WizMenu/WizMenu'
import {IGlobalNavigationStyles} from '@component/header/GlobalNavigation/GlobalNavigation'

import NavButton from '@component/header/GlobalNavigation/NavButton'
import WizCustomMenu from '@component/menu/WizMenu/WizCustomMenu'
import ChatMenuItem from '@pages/chart/component/chat/items/ChatMenuItem'
import NewTag from '@component/tags/NewTag'

import IconNew from '@svg/common/ic_new.svg'
import IconDown from '@svg/common/ic_btn_down.svg'

interface IProps {
    className?: string
    navStyles?: IGlobalNavigationStyles
    isScrolled?: boolean
}

const marginTop = 20
const NavigationFeaturesTitle = ({className, navStyles, isScrolled}: IProps) => {
    const t = useTranslation()
    const router = useRouter()
    const menuItems: WMOption[] = useMemo(() => {
        const list: WMOption[] = [
            {
                id: 'chat',
                value: (
                    <ChatMenuItem
                        text={t('globalNavigation.menu.chat')}
                        textClassName={
                            'text-btn_sm text-gray01 dark:text-dark_gray01 group-hover:text-gray01 dark:group-hover:text-dark_gray01'
                        }
                        className={
                            'mx-[5px] py-[10px] px-[15px] rounded-[5px] hover:bg-gray08 dark:hover:bg-dark_gray08 gap-x-[5px]'
                        }
                        rightContent={
                            <IconNew className={'w-[10px] h-[10px] fill-red_shade dark:fill-dark_red_shade'} />
                        }
                    />
                ),
                onClick: () => router.push(URL_CHART),
            },
        ]

        list.push({
            id: 'ai',
            value: (
                <ChatMenuItem
                    text={t('globalNavigation.menu.ai')}
                    textClassName={
                        'text-btn_sm text-gray01 dark:text-dark_gray01 group-hover:text-gray01 dark:group-hover:text-dark_gray01'
                    }
                    className={'mx-[5px] py-[10px] px-[15px] rounded-[5px] hover:bg-gray08 dark:hover:bg-dark_gray08'}
                />
            ),
            onClick: () => router.push(URL_AI),
        })
        list.push({
            id: 'meme',
            value: (
                <ChatMenuItem
                    text={t('globalNavigation.menu.meme')}
                    textClassName={
                        'text-btn_sm text-gray01 dark:text-dark_gray01 group-hover:text-gray01 dark:group-hover:text-dark_gray01'
                    }
                    className={'mx-[5px] py-[10px] px-[15px] rounded-[5px] hover:bg-gray08 dark:hover:bg-dark_gray08'}
                />
            ),
            onClick: () => router.push(URL_MEME),
        })
        return list
    }, [t])

    const matchingCondition = useMemo(() => {
        return [
            {type: MatchingType.Equal, url: URL_CHART},
            {type: MatchingType.Equal, url: URL_AI},
            {type: MatchingType.Equal, url: URL_MEME},
        ]
    }, [])

    return (
        <WizCustomMenu
            enableHover
            items={menuItems}
            placement={'bottom'}
            className={'group'}
            innerClassName={'py-[5px] space-y-[5px]'}
            floatingStyle={{marginTop}}>
            <NavButton
                textClassName={navStyles?.TextPrimaryColor}
                text={t('globalNavigation.menu.features')}
                href={getLinkUrl(matchingCondition?.at(0)?.url)}
                matchingCondition={matchingCondition}
                rightIcon={<RightIcon logoType={navStyles?.logoType} />}
                isScrolled={isScrolled}
            />
        </WizCustomMenu>
    )
}
export default NavigationFeaturesTitle

const RightIcon = ({logoType}: {logoType: 'default' | 'white'}) => {
    return (
        <span className={'flex items-center gap-x-[3px]'}>
            <NewTag />
            <IconDown
                className={`w-[10px] h-[10px] ${
                    logoType === 'white' ? 'fill-dark_gray01' : 'fill-gray01 dark:fill-dark_gray01'
                } group-hover:-rotate-180 transition-transform`}
            />
        </span>
    )
}
